import { City } from '@/lib/map/types';

const cities: City[] = [
    {
        id: 'shanghai',
        name: 'Shanghai',
        edito: '',
        subtitle: '',
        about: '',
        bounds: [
            [121.41132742324771, 31.179231619930576],
            [121.56222044527658, 31.274483881128248],
        ],
        videos: [
            'https://www.youtube.com/watch?v=usXHh1GNXgg',
            'https://www.youtube.com/watch?v=eahhRtmE0GI',
            'https://youtu.be/KTYUJh5D7Fg',
        ],
    },
    {
        id: 'hongkong',
        name: 'Hong Kong',
        smallName: 'HK',
        edito: '',
        subtitle: '',
        about: '',
        bounds: [
            [114.30947948368129, 22.418878996495977],
            [114.02924271631633, 22.219657710521872],
        ],
        videos: ['https://www.youtube.com/watch?v=kp6rJnn06PU'],
    },
    // {
    //     id: 'singapore',
    //     name: 'Singapore',
    //     edito: '',
    //     subtitle: '',
    //     about: '',
    //     bounds: [
    //         [103.79195666582484, 1.261332366626064],
    //         [103.89591805260989, 1.3380576970246523],
    //     ],
    // },
    {
        id: 'berlin',
        name: 'Berlin',
        edito: '',
        subtitle: '',
        about: '',
        bounds: [
            [13.32656832456459, 52.48460557999883],
            [13.479100661227648, 52.55162108387398],
        ],
        videos: [
            'https://www.youtube.com/watch?v=7xs94hr2clo',
            'https://vimeo.com/174566374',
            'https://www.youtube.com/watch?v=zc469HJWoeQ',
            'https://www.youtube.com/watch?v=9t0qkZqwwWg',
            'https://www.youtube.com/watch?v=33dhfy4vFBw',
            'https://vimeo.com/138208071',
            'https://www.youtube.com/watch?v=fYybWqGYVx4',
            'https://www.youtube.com/watch?v=G8dnrwPYhZU',
            'https://www.youtube.com/watch?v=9t0qkZqwwWg',
            'https://www.youtube.com/watch?v=UFotH68rf_8',
            'https://vimeo.com/223248660',
            'https://vimeo.com/224714861',
            'https://vimeo.com/227394921',
            'https://vimeo.com/219583089',
            'https://vimeo.com/228588464',
            'https://www.youtube.com/watch?v=hga0PeKt_3I',
            'https://www.youtube.com/watch?v=Pj2kUH0frMo',
            'https://vimeo.com/151945481',
            'https://vimeo.com/230916788',
            'https://www.youtube.com/watch?v=2RF_SivYaFg',
            'https://vimeo.com/235825360',
            'https://www.youtube.com/watch?v=YyOuIJ3Q0k8',
            'https://www.youtube.com/watch?v=oDW9uiRtWKs',
            'https://www.youtube.com/watch?v=CX9TIc7git4',
            'https://www.youtube.com/watch?v=oogQAlis58M',
            'https://www.youtube.com/watch?v=aZ3jNhr9KHQ',
            'https://www.youtube.com/watch?v=4xFo_mpABFQ',
            'https://www.youtube.com/watch?v=I4HNywY47xs',
            'https://www.youtube.com/watch?v=U6gTHY555qs',
            'https://vimeo.com/305474080',
            'https://vimeo.com/307008090',
            'https://youtu.be/4e7Kw0oZ2Dg',
            'https://youtu.be/UsAo6rFgnTo',
            'https://youtu.be/yGgCmkcNkDY',
            'https://youtu.be/kD6tSr5i9qk',
            'https://youtu.be/8QmPz6mhyWo',
            'https://youtu.be/OsRId31vV18',
            'https://youtu.be/iXHnVCIgu1A',
            'https://youtu.be/w40HCBogdIQ',
            'https://vimeo.com/332193669',
            'https://youtu.be/Em6OI0_OqKY',
            'https://youtu.be/uxks0be0Ku8',
            'https://youtu.be/zs41p7pUDio',
            'https://youtu.be/BeDWV5CZyoA',
            'https://vimeo.com/375775332',
            'https://youtu.be/FDiCYXAzIVI',
        ],
    },
    {
        id: 'bxl',
        name: 'Brussels',
        edito: '',
        subtitle: '',
        about: '',
        bounds: [
            [4.277965327313439, 50.81331667594927],
            [4.430497663976553, 50.882850657408625],
        ],
        videos: [
            'https://www.youtube.com/watch?v=8fjQVxLhYRg',
            'https://vimeo.com/171483667',
            'https://vimeo.com/382811353',
            'https://vimeo.com/459413966',
            'https://www.youtube.com/watch?v=6pnRwv_5qOw',
            'https://www.youtube.com/watch?v=psfEQgoldqI',
            'https://www.youtube.com/watch?v=h3Mz7U7q3iI',
            'https://www.youtube.com/watch?v=B_Un2z9tjYU',
            'https://www.youtube.com/watch?v=JFJVSSWR94I',
            'https://www.youtube.com/watch?v=f7o717sTnJ0',
            'https://www.youtube.com/watch?v=Dml6_vIcKgo',
            'https://www.youtube.com/watch?v=qkFwfITueYU',
            'https://www.youtube.com/watch?v=u3eKJBwLmiI',
            'https://www.youtube.com/watch?v=ylKfDo1IBXM',
            'https://www.youtube.com/watch?v=BVY6Kf5Xd0E',
        ],
    },
    {
        id: 'lyon',
        name: 'Lyon',
        edito: 'Where this whole Krak idea started!',
        subtitle: 'HDV everyday, all day!',
        about: "Lyon is one of the major city in the french skate scene. Lots of legends came to film with Mr Fred Mortagne 20 years ago and made all these spots worldwide famous! You can still frequently meet pros passing by on the spots. Add to that the skateparks, the incredible and recently renewed HDV Plaza spot! You can't ask any better than this to have fun on your board!",
        bounds: [
            [4.787438796352205, 45.738004310175],
            [4.883625037813516, 45.78802185177571],
        ],
        videos: [
            'https://vimeo.com/187814824',
            'https://vimeo.com/198635451',
            'https://vimeo.com/195296310',
            'https://vimeo.com/177250212',
            'https://www.youtube.com/watch?v=BhCpfZ3Uxh0',
            'https://www.youtube.com/watch?v=b1YMnLBsdKg',
            'https://vimeo.com/224830149',
            'https://www.youtube.com/watch?v=uRMaC4BUS4k',
            'https://vimeo.com/245813748',
            'https://www.youtube.com/watch?v=EV05cQvaRqY',
            'https://youtu.be/LrZFLFCQ8Is',
            'https://youtu.be/aYGNerG2Zso',
            'https://youtu.be/5_GYTtesI4g',
            'https://vimeo.com/375884098',
            'https://youtu.be/lK4N0T1cCXg',
        ],
    },
    {
        id: 'paris',
        name: 'Paris',
        edito: 'The city of Love!',
        subtitle: 'We love Paris sidewalks!',
        about: `
Paris is a paradise for skateboarders! From its concrete sidewalks perfect to go get your baguette in the morning to all these iconic spots still receiving their fair amount of destruction nowadays, Paris is the place to be!
        `,
        bounds: [
            [2.2548510078733557, 48.810511704540005],
            [2.4308845217189514, 48.9121314930525],
        ],
        videos: [
            'https://www.youtube.com/watch?v=icOVL1G6Rm4',
            'https://vimeo.com/187463463',
            'https://vimeo.com/188900867',
            'https://vimeo.com/187614982',
            'https://www.youtube.com/watch?v=ieEQ0w7NryM',
            'https://www.youtube.com/watch?v=UWNG68M9QJc',
            'https://www.youtube.com/watch?v=icOVL1G6Rm4',
            'https://www.youtube.com/watch?v=ldpNR3Yoijo',
            'https://www.youtube.com/watch?v=Wc9KSh7ZN7U',
            'https://vimeo.com/193339176',
            'https://www.youtube.com/watch?v=j-R7TGEW2zc',
            'https://www.youtube.com/watch?v=icOVL1G6Rm4',
            'https://www.youtube.com/watch?v=-J8DHFumE9Y',
            'https://www.youtube.com/watch?v=qwV_V-ps08o',
            'https://www.youtube.com/watch?v=ucqGbkivARU',
            'https://www.youtube.com/watch?v=MZlVGCBdwzw',
            'https://vimeo.com/178269832',
            'https://vimeo.com/205949484',
            'https://www.youtube.com/watch?v=HdIJbeppo0M',
            'https://vimeo.com/210946788',
            'https://www.youtube.com/watch?v=TfEu0ir5OW4',
            'https://www.youtube.com/watch?v=3Fnfy-w1hbE',
            'https://vimeo.com/164550731',
            'https://www.youtube.com/watch?v=FfmucvaCrMU',
            'https://www.youtube.com/watch?v=jQgw5RH27aE',
            'https://www.youtube.com/watch?v=1TDF43oc4GA',
            'https://www.youtube.com/watch?v=1TDF43oc4GA',
            'https://www.youtube.com/watch?v=QcGeIEas0ig',
            'https://vimeo.com/227316633',
            'https://vimeo.com/227942614',
            'https://vimeo.com/228231599',
            'https://vimeo.com/229858273',
            'https://www.youtube.com/watch?v=HE3yliFXTBY',
            'https://vimeo.com/233509063',
            'https://www.youtube.com/watch?v=sm8D9kXYhgo',
            'https://www.youtube.com/watch?v=ZombPbi1h7I',
            'https://www.youtube.com/watch?v=r5IY4mcw7SA',
            'https://vimeo.com/235528729',
            'https://www.youtube.com/watch?v=f6CUChSDjVw',
            'https://vimeo.com/228786110',
            'https://www.youtube.com/watch?v=arcJ6sWBaXg',
            'https://vimeo.com/238185825',
            'https://vimeo.com/238723872',
            'https://www.youtube.com/watch?v=ssEFWe3x40I',
            'https://www.youtube.com/watch?v=x4nbd0DzBUo',
            'https://www.youtube.com/watch?v=2tudo5zQ-8o',
            'https://vimeo.com/247673317',
            'https://www.youtube.com/watch?v=OzlLvk2cHJo',
            'https://www.youtube.com/watch?v=k2o3OlHG-48',
            'https://vimeo.com/269669826',
            'https://www.youtube.com/watch?v=QHgl0vJO6SY',
            'https://www.youtube.com/watch?v=dbF8Zwq7gIQ',
            'https://www.youtube.com/watch?v=rfe57y6uYVs',
            'https://www.youtube.com/watch?v=sDlxPt0cYUw',
            'https://vimeo.com/313751600',
            'https://youtu.be/cBZGUjgK88M',
            'https://youtu.be/avaKC17N5Do',
            'https://youtu.be/FR572I2F710',
            'https://youtu.be/1-Km1YnH6Vo',
            'https://vimeo.com/296177817',
            'https://youtu.be/rfe57y6uYVs',
            'https://youtu.be/hl5WGykWWUc',
            'https://youtu.be/P-JABHgYjIw',
            'https://youtu.be/YXX0DRfd9Hc',
            'https://vimeo.com/292658104',
            'https://youtu.be/uDCgBISD89s',
            'https://vimeo.com/287525452',
            'https://youtu.be/qGAAXPFGR8g',
            'https://youtu.be/IrfMLly91fg',
            'https://vimeo.com/253340248',
            'https://youtu.be/zOPZvp5OzpM',
            'https://youtu.be/8Ik0Ws8Fvvc',
            'https://youtu.be/TVj5U69vbRg',
            'https://vimeo.com/333916706',
            'https://youtu.be/VuR7m7sHY18',
            'https://youtu.be/XutaQsauhaY',
            'https://youtu.be/NhuGbxS5T-w',
            'https://vimeo.com/348261044',
            'https://youtu.be/J6-kwH_Qv-s',
            'https://youtu.be/YYB-F3YwU5c',
            'https://youtu.be/P7ktnYfL77c',
            'https://vimeo.com/367591176',
            'https://youtu.be/2BKsZ-YlluE',
            'https://youtu.be/vXaIb_tN7c0',
            'https://youtu.be/PXzN7xXA1lE',
            'https://vimeo.com/375222964',
            'https://youtu.be/ou3NsPDS9Kw',
            'https://youtu.be/BXm6gwC7Uxc',
            'https://youtu.be/FW47zlui3tc',
            'https://youtu.be/Mhm9-PWcEt0',
            'https://vimeo.com/391843566',
            'https://youtu.be/FdK5nRkWXUw',
            'https://vimeo.com/395375085',
            'https://youtu.be/WV_NObYeemI',
            'https://youtu.be/MXtzIZ2a5rE',
            'https://youtu.be/96DGzKdYJ7E',
            'https://youtu.be/FdK5nRkWXUw',
            'https://youtu.be/zflBNksem5M',
            'https://youtu.be/slNmIlJ_Pdc',
        ],
    },
    {
        id: 'london',
        name: 'London',
        edito: '',
        subtitle: '',
        about: '',
        bounds: [
            [-0.23693493552042355, 51.457159797428545],
            [-0.018581664037128576, 51.557486774307336],
        ],
        videos: [
            'https://www.youtube.com/watch?v=RSW1pHP394Y',
            'https://www.youtube.com/watch?v=tM4F3VNu6UI',
            'https://www.youtube.com/watch?v=x7L_r-GoFws',
            'https://www.youtube.com/watch?v=Uxx2OC_rKaI',
            'https://www.youtube.com/watch?v=CmfSIjiwovk',
            'https://www.youtube.com/watch?v=caOPgt4yVDg',
            'https://www.youtube.com/watch?v=AQqeUt2wO1Y',
            'https://www.youtube.com/watch?v=KncX8EOTy1s',
            'https://www.youtube.com/watch?v=6uVLuBLC3J0',
            'https://www.youtube.com/watch?v=UI1PoZtozMs',
            'https://vimeo.com/177745411',
            'https://www.youtube.com/watch?v=KMeafBbOCO4',
            'https://vimeo.com/173886176',
            'https://www.youtube.com/watch?v=rIGlDCHG3zs',
            'https://www.youtube.com/watch?v=P_DYLrfcJL0',
            'https://www.youtube.com/watch?v=u0RNyKSedlc',
            'https://www.youtube.com/watch?v=EL5vDbZ9X6I',
            'https://vimeo.com/208181344',
            'https://www.youtube.com/watch?v=QW8Ob7DwPik',
            'https://www.youtube.com/watch?v=caOPgt4yVDg',
            'https://www.youtube.com/watch?v=qRs2A7BmebY',
            'https://www.youtube.com/watch?v=C6Ey4t4Uq2o',
            'https://vimeo.com/189755944',
            'https://www.youtube.com/watch?v=wGkuqlmM8JU',
            'https://vimeo.com/209825415',
            'https://www.youtube.com/watch?v=fEHl1iGK_cM',
            'https://vimeo.com/226823266',
            'https://www.youtube.com/watch?v=60E99uHJ8ME',
            'https://www.youtube.com/watch?v=azz__9m_gEc',
            'https://www.youtube.com/watch?v=QfcGKX-ou90',
            'https://www.youtube.com/watch?v=n8pzCmzVSjE',
            'https://www.youtube.com/watch?v=n8pzCmzVSjE',
            'https://www.youtube.com/watch?v=7fERlooYkPs',
            'https://www.youtube.com/watch?v=I9NGCb-sHbs',
            'https://www.youtube.com/watch?v=cFwytlpCJ9U',
            'https://www.youtube.com/watch?v=o6QTnX-0hNY',
            'https://vimeo.com/243332735',
            'https://www.youtube.com/watch?v=YhO7nQeeGPw',
            'https://vimeo.com/243696302',
            'https://www.youtube.com/watch?v=IpQWBeyOzLE',
            'https://youtu.be/IpQWBeyOzLE',
            'https://youtu.be/Vz5stzlH4nA',
            'https://vimeo.com/273400189',
            'https://vimeo.com/272261673',
            'https://youtu.be/WgCqD8vo2Qg',
            'https://youtu.be/0ueLaH2IbMw',
            'https://vimeo.com/276782196',
            'https://youtu.be/9x7WvOIbdF8',
            'https://youtu.be/HjK7gwylHJM',
            'https://youtu.be/k59hbzhZK6k',
            'https://youtu.be/HkeeDwriq3I',
            'https://youtu.be/wARr6N0T-xA',
            'https://youtu.be/KAow-L716EM',
            'https://youtu.be/O212YNil2pI',
            'https://youtu.be/fKu0jht7O1o',
        ],
    },
    {
        id: 'barcelona',
        name: 'Barcelona',
        edito: 'Euro skate capital',
        subtitle: 'Macbalife!',
        about: "You can netflix n chill at Macba all day or you can go discover the crazy amount of piece of art the architectures have created in this spanish playground! It's also a wild place for the party night life..",
        bounds: [
            [2.0576750759531706, 41.32263417922036],
            [2.279536643486864, 41.4467123861632],
        ],
        videos: [
            'https://www.youtube.com/watch?v=fF9OWwedQt8',
            'https://www.youtube.com/watch?v=Gvvu1Gfkhdo',
            'https://www.youtube.com/watch?v=2IDSb-kxn3Q',
            'https://www.youtube.com/watch?v=3Y3R7EcfDQw',
            'https://www.youtube.com/watch?v=-P78KK67KRE',
            'https://www.youtube.com/watch?v=yHKwSYCmjGc',
            'https://www.youtube.com/watch?v=moctV99mS8Y',
            'https://www.youtube.com/watch?v=gDCV_rwIgDI',
            'https://www.youtube.com/watch?v=TuZW52-OjoU',
            'https://www.youtube.com/watch?v=rQbeMzMT7vM',
            'https://vimeo.com/177774981',
            'https://vimeo.com/198585642',
            'https://www.youtube.com/watch?v=CxzQ7_uN5KU',
            'https://www.youtube.com/watch?v=LdUu2N3YI5Q',
            'https://www.youtube.com/watch?v=dQZRJqvS8oc',
            'https://www.youtube.com/watch?v=k1z5eqvUD0A',
            'https://www.youtube.com/watch?v=TZth0_Ay41U',
            'https://www.youtube.com/watch?v=k3mjfYkFUwE',
            'https://www.youtube.com/watch?v=TZth0_Ay41U',
            'https://www.youtube.com/watch?v=9Oc3Eq-vNt8',
            'https://www.youtube.com/watch?v=r36_ZGC1YVE',
            'https://www.youtube.com/watch?v=iV_0susVjHs',
            'https://www.youtube.com/watch?v=DrLC1cjbwFU',
            'https://www.youtube.com/watch?v=Xwo0Z1Rh9CA',
            'https://www.youtube.com/watch?v=d0etWair4ps',
            'https://vimeo.com/163387280',
            'https://www.youtube.com/watch?v=cKIgkYXQqZA',
            'https://www.youtube.com/watch?v=rQbeMzMT7vM',
            'https://www.youtube.com/watch?v=djNZVqYuyLw',
            'https://www.youtube.com/watch?v=iwE4E-QHFig',
            'https://www.youtube.com/watch?v=0OOSjgI7ogA',
            'https://www.youtube.com/watch?v=rD4Clctj3aM',
            'https://www.youtube.com/watch?v=eKh1u-DPNoE',
            'https://www.youtube.com/watch?v=qrCVN7dCKG4',
            'https://www.youtube.com/watch?v=QtdhtflBuGg',
            'https://www.youtube.com/watch?v=6xMKZ8BdF8M',
            'https://www.youtube.com/watch?v=bdl8lpUCsMw',
            'https://www.youtube.com/watch?v=Xk1XfnPokWY',
            'https://vimeo.com/165020689',
            'https://vimeo.com/163240418',
            'https://www.youtube.com/watch?v=hDaBrWZRFEE',
            'https://www.youtube.com/watch?v=VgaQB0Fz_6A',
            'https://www.youtube.com/watch?v=RGWZUTHiDzI',
            'https://www.youtube.com/watch?v=O13yIqMDHyY',
            'https://www.youtube.com/watch?v=1hDBXun4Yxo',
            'https://www.youtube.com/watch?v=5LIldncSqLI',
            'https://vimeo.com/214044348',
            'https://www.youtube.com/watch?v=m7q0EIYKxqo',
            'https://www.youtube.com/watch?v=13MEsdeS3wY',
            'https://vimeo.com/229100321',
            'https://www.youtube.com/watch?v=IL3nzgcxFm8',
            'https://vimeo.com/230842363',
            'https://www.youtube.com/watch?v=NExSo1jlb60',
            'https://www.youtube.com/watch?v=a0JX6ALXcqs',
            'https://www.youtube.com/watch?v=TXvR-eZ2ZRU',
            'https://www.youtube.com/watch?v=Rk0IBBwj8VU',
            'https://www.youtube.com/watch?v=7nMn91jnk3U',
            'https://www.youtube.com/watch?v=Dba9ROlY-Hk',
            'https://www.youtube.com/watch?v=6sA3j7-XZAk',
            'https://www.youtube.com/watch?v=Kp6BPDVQtZM',
            'https://www.youtube.com/watch?v=qyjU9dFMDLA',
            'https://youtu.be/-hGuAeahG4w',
            'https://youtu.be/kQQNm1znWMs',
            'https://vimeo.com/285383969',
            'https://youtu.be/J9k7QgIHg0I',
            'https://youtu.be/2i-pc1yNP5U',
            'https://youtu.be/EMBs59Vd1h0',
            'https://vimeo.com/253005512',
            'https://youtu.be/ouf2vL_jDRk',
            'https://vimeo.com/274020514',
            'https://youtu.be/_eY5PrHxO6U',
            'https://youtu.be/fxEb2rSrEXQ',
            'https://youtu.be/6sA3j7-XZAk',
            'https://youtu.be/EOkLKMbxcBE',
            'https://youtu.be/2i-pc1yNP5U',
            'https://youtu.be/5i8DXcfDOww',
            'https://youtu.be/br19MGRIY20',
            'https://youtu.be/D1GxPMCX3jA',
            'https://youtu.be/t2MMcxcpYxs',
            'https://youtu.be/ZPCbsMA5r20',
            'https://youtu.be/sFNr3JLFS5Y',
            'https://youtu.be/aSoACIE1Zvc',
            'https://youtu.be/FNMJaDxjk-k',
            'https://youtu.be/UEHbAkb0Xpc',
            'https://youtu.be/eSuLelzK1vk',
            'https://youtu.be/xbmvqejtO9o',
            'https://youtu.be/ObqITOByqXw',
            'https://youtu.be/tgCubvRXdPw',
            'https://youtu.be/AUPegfXViAs',
            'https://youtu.be/7wSkxCxz2jA',
            'https://vimeo.com/396439638',
            'https://youtu.be/DiglbmXGxt4',
        ],
    },
    {
        id: 'saopaulo',
        name: 'São Paulo',
        edito: '',
        subtitle: '',
        about: '',
        bounds: [
            [-46.52233501688306, -23.465244811663993],
            [-46.75621642127189, -23.630010501861648],
        ],
        videos: [
            'https://vimeo.com/206652598',
            'https://www.youtube.com/watch?v=y29nvheBjaY',
            'https://youtu.be/XGmXMuLKEMc',
            'https://youtu.be/SaUwp7yXTWI',
        ],
    },
    // {
    //     id: 'brooklyn',
    //     name: 'Brooklyn',
    //     edito: '',
    //     subtitle: '',
    //     about: '',
    //     bounds: [
    //         [-74.0619176038734, 40.617289129755534],
    //         [-73.84356433239117, 40.73953236875826],
    //     ],
    // },
    {
        id: 'nyc',
        name: 'New York City',
        smallName: 'New York',
        edito: 'The Big Apple',
        subtitle: 'The City of Lights!',
        about: "New York City has always been a huge part of the american and worldwide history! With so many typical spots you can tell it's New York, it has a charme you can't deny if you like urban street skating! Thank you Bobby Puelo, Tyshawn Jones, and all those in between! ",
        bounds: [
            [-74.07686383082431, 40.69836309341969],
            [-73.8844913479055, 40.80698836737918],
        ],
        videos: [
            'https://vimeo.com/188307428',
            'https://www.youtube.com/watch?v=zCTmRzuxlbk',
            'https://www.youtube.com/watch?v=rI56Y4xyHCM',
            'https://www.youtube.com/watch?v=MC9qAGqM5IM',
            'https://vimeo.com/187541257',
            'https://vimeo.com/187044460',
            'https://vimeo.com/185685983',
            'https://www.youtube.com/watch?v=bO-CYc-1pgw',
            'https://vimeo.com/189380378',
            'https://vimeo.com/183412977',
            'https://www.youtube.com/watch?v=Pacaw68GGYQ',
            'https://vimeo.com/190968190',
            'https://www.youtube.com/watch?v=Zcupv-Njuyk',
            'https://www.youtube.com/watch?v=AGSCFDIm9wg',
            'https://www.youtube.com/watch?v=PMSSX5EU8Vg',
            'https://www.youtube.com/watch?v=J6UmIVSswmE',
            'https://www.youtube.com/watch?v=ZQkpJRSCDmM',
            'https://www.youtube.com/watch?v=8ao5ALAwksk',
            'https://vimeo.com/197643647',
            'https://www.youtube.com/watch?v=WDqnNTypWyQ',
            'https://www.youtube.com/watch?v=e8R08dX9hWA',
            'https://www.youtube.com/watch?v=Cq8D54NVjZg',
            'https://www.youtube.com/watch?v=M7J8Skqb53A',
            'https://www.youtube.com/watch?v=-7aTVYRPW-8',
            'https://www.youtube.com/watch?v=9gUw-ypdxIQ',
            'https://www.youtube.com/watch?v=xVfeqUtSHdA',
            'https://www.youtube.com/watch?v=yDEMlT11FnI',
            'https://www.youtube.com/watch?v=mS8echATY-Q',
            'https://www.youtube.com/watch?v=JKPwLwhE-8M',
            'https://www.youtube.com/watch?v=TUzE6vmR9s0',
            'https://www.youtube.com/watch?v=N_5VaHnDGB4',
            'https://vimeo.com/176054806',
            'https://vimeo.com/173256374',
            'https://www.youtube.com/watch?v=6ewirevBfsU',
            'https://www.youtube.com/watch?v=fdz0e1qK4e4',
            'https://vimeo.com/138016749',
            'https://www.youtube.com/watch?v=v1_-nosktdg',
            'https://vimeo.com/148367665',
            'https://vimeo.com/148112317',
            'https://vimeo.com/170990620',
            'https://www.youtube.com/watch?v=N1lJosVLKgY',
            'https://www.youtube.com/watch?v=di37-QDkOEo',
            'https://www.youtube.com/watch?v=5P1-AwGkTUs',
            'https://www.youtube.com/watch?v=WX2h6BVEwHo',
            'https://www.youtube.com/watch?v=hmgySwACRpc',
            'https://www.youtube.com/watch?v=09C5C5zDhG4',
            'https://www.youtube.com/watch?v=uwyFIZVgDM8',
            'https://www.youtube.com/watch?v=B0mKnOOt7kY',
            'https://www.youtube.com/watch?v=UxPoUXlzP5o',
            'https://www.youtube.com/watch?v=poExkWnZ9W8',
            'https://vimeo.com/190233204',
            'https://www.youtube.com/watch?v=S_pmUxsczFI',
            'https://www.youtube.com/watch?v=BwpBvNc4xKk',
            'https://www.youtube.com/watch?v=9Rd8LZAtWdw',
            'https://www.youtube.com/watch?v=9Kbien7C27Y',
            'https://www.youtube.com/watch?v=w1oFGHnHbbs',
            'https://www.youtube.com/watch?v=N6igHkfphMo',
            'https://www.youtube.com/watch?v=99Cuwdjr19I',
            'https://www.youtube.com/watch?v=ZsCJb7ZLTtg',
            'https://www.youtube.com/watch?v=nTaSC4hnWrs',
            'https://www.youtube.com/watch?v=CAc-rDuXZ5M',
            'https://vimeo.com/222711836',
            'https://www.youtube.com/watch?v=m2699tN7Y9s',
            'https://www.youtube.com/watch?v=Vty0FdoArT4',
            'https://www.youtube.com/watch?v=O8WS9-1qVuw',
            'https://www.youtube.com/watch?v=NVi2zqU6cOg',
            'https://www.youtube.com/watch?v=DekQfpXsHRk',
            'https://www.youtube.com/watch?v=q9evDURsuv8',
            'https://www.youtube.com/watch?v=ng1iVAmUvhM',
            'https://vimeo.com/133048183',
            'https://www.youtube.com/watch?v=mPjlyp22lLQ',
            'https://www.youtube.com/watch?v=C0yUiEvLqEY',
            'https://www.youtube.com/watch?v=JO0SBpd3bu4',
            'https://www.youtube.com/watch?v=S6LNylIc6yk',
            'https://www.youtube.com/watch?v=qsEk2211vi4',
            'https://vimeo.com/234927368',
            'https://www.youtube.com/watch?v=1n3fEG7Nz98',
            'https://www.youtube.com/watch?v=hDEAGA95jDY',
            'https://www.youtube.com/watch?v=nAHk0FKPtFg',
            'https://www.youtube.com/watch?v=JwTJKdkPGEc',
            'https://www.youtube.com/watch?v=NUeAt2IwOMI',
            'https://www.youtube.com/watch?v=6X9A_XI60X4',
            'https://www.youtube.com/watch?v=ng9ZIV_NSHs',
            'https://vimeo.com/242163458',
            'https://www.youtube.com/watch?v=ng9ZIV_NSHs',
            'https://www.youtube.com/watch?v=D46oCCud5vU',
            'https://vimeo.com/234927368',
            'https://www.youtube.com/watch?v=s-81mtEi76U',
            'https://vimeo.com/247865799',
            'https://www.youtube.com/watch?v=ilkdFUKb3EI',
            'https://www.youtube.com/watch?v=YlqKBWM5nZc',
            'https://www.youtube.com/watch?v=D0rEV3zdZwM',
            'https://www.youtube.com/watch?v=VkQqatego8A',
            'https://vimeo.com/311116044',
            'https://youtu.be/Kkzv-nsDVi8',
            'https://youtu.be/b-vM2142gQs',
            'https://youtu.be/SaoAixcMF70',
            'https://vimeo.com/311116044',
            'https://youtu.be/GblXXFk0Xjw',
            'https://youtu.be/vvdzHIFZ7Mg',
            'https://youtu.be/NS6tI4q2v7A',
            'https://youtu.be/inkmdfTw75o',
            'https://youtu.be/IL6iVopjZdk',
            'https://youtu.be/c38AdXxAwZc',
            'https://youtu.be/d4wUvdmH1ao',
            'https://youtu.be/d4wUvdmH1ao',
            'https://youtu.be/WxVuYSjUXeo',
            'https://youtu.be/bfMY3dJzyUc',
            'https://youtu.be/X3QpZ592mnw',
            'https://youtu.be/2RS9iQgYc3k',
            'https://youtu.be/qqcISVM6LiA',
            'https://youtu.be/IVUvpPKGPZ0',
            'https://youtu.be/wAQPoHT8Z6M',
            'https://youtu.be/oFs1VGstNa0',
            'https://youtu.be/K0XqeOMhZXA',
            'https://youtu.be/Cq4D7ERegd8',
            'https://youtu.be/_4dPSa1LtpY',
            'https://youtu.be/2RS9iQgYc3k',
            'https://vimeo.com/322664751',
            'https://youtu.be/P8EUSujJiTw',
            'https://youtu.be/XFLszefeRO0',
            'https://youtu.be/QH2jkPt4aeM',
            'https://youtu.be/inkmdfTw75o',
            'https://youtu.be/QH2jkPt4aeM',
            'https://youtu.be/LOwvbMy8Br8',
            'https://youtu.be/ySt3qzWyqsU',
            'https://youtu.be/rEx-iwVDzdo',
            'https://youtu.be/DAg7AMoi6Jc',
            'https://youtu.be/tqh68w06wvM',
            'https://youtu.be/jdgjBcabUtA',
            'https://youtu.be/KFbTdTzVtQ8',
            'https://youtu.be/7Oy0cB-AwFk',
            'https://youtu.be/DAg7AMoi6Jc',
            'https://youtu.be/obQeS5Wt3QA',
            'https://youtu.be/2cYV31-Hkm8',
            'https://youtu.be/3C9a645-3F8',
            'https://youtu.be/VGRePkrPXWc',
            'https://youtu.be/gV8k1d1Ohg4',
            'https://youtu.be/Q6Hu27a4aO4',
            'https://youtu.be/M2I5fJssQOk',
            'https://youtu.be/yt3JC6Ng_qQ',
            'https://youtu.be/GddjdI7DCOU',
            'https://youtu.be/bmuXdgkqR6Y',
            'https://youtu.be/WLryrmF3mf0',
            'https://youtu.be/nCqyHoqx6Rw',
            'https://youtu.be/0aAAXNeeark',
            'https://youtu.be/lVehwHMdW3g',
            'https://youtu.be/iwbOq_P-j-w',
            'https://youtu.be/eSGBc3bXmY8',
            'https://youtu.be/2Y__n0GpOwQ',
            'https://vimeo.com/382202331',
            'https://youtu.be/PkDd-eOtIow',
            'https://youtu.be/wTLYGt2Xu5A',
            'https://youtu.be/6d4d-LegLW8',
            'https://youtu.be/JOpOqxkOnTE',
            'https://youtu.be/6el6lS4nVWA',
            'https://youtu.be/z15LcHywIOI',
            'https://youtu.be/OHdOJhOT7hc',
            'https://youtu.be/2XYTt_SCEnU',
            'https://vimeo.com/409773528',
            'https://youtu.be/PTNigASSKkA',
            'https://youtu.be/HI1ZlEdWWJg',
            'https://youtu.be/ovl3N4_9RDs',
            'https://youtu.be/jXHA5hpBMO0?si=aaS1rLHSRTmwwFkF',
        ],
    },
    {
        id: 'la',
        name: 'Los Angeles',
        smallName: 'LA',
        edito: '',
        subtitle: '',
        about: '',
        bounds: [
            [-118.52225298698305, 33.91312229261048],
            [-118.09015125444574, 34.17163863207952],
        ],
        videos: [
            'https://youtu.be/odupTp2hHLM',
            'https://www.youtube.com/watch?v=HjAe5gXw0jk',
            'https://www.youtube.com/watch?v=ZKbNtzhRnNg',
            'https://www.youtube.com/watch?v=h0ODGRGwLrc',
            'https://www.youtube.com/watch?v=HcMWo0BoKjs',
            'https://www.youtube.com/watch?v=-5YyHNVA3Z0',
            'https://www.youtube.com/watch?v=mfjWAa3v6IQ',
            'https://www.youtube.com/watch?v=mxy1aOFHQHo',
            'https://www.youtube.com/watch?v=GwAqyFoKwAs',
            'https://www.youtube.com/watch?v=5gpH0eVfxaU',
            'https://www.youtube.com/watch?v=u2TGQ5EYIZE',
            'https://www.youtube.com/watch?v=Ygcvnc86ZXY',
            'https://www.youtube.com/watch?v=AoJRg6LDjJw',
            'https://www.youtube.com/watch?v=9QrUpzOY9R0',
            'https://www.youtube.com/watch?v=I8bK8qrBRi8',
            'https://www.youtube.com/watch?v=jORJu7uxDsk',
            'https://www.youtube.com/watch?v=GmESm3ap-sA',
            'https://www.youtube.com/watch?v=1DDWLVW6tCw',
            'https://www.youtube.com/watch?v=9WnVmr6i_0Q',
            'https://www.youtube.com/watch?v=yUofLhtQltw',
            'https://www.youtube.com/watch?v=v1PvQ6YGQ6A',
            'https://www.youtube.com/watch?v=z8dw9QHZ3fI',
            'https://www.youtube.com/watch?v=RbEZPKt9xqU',
            'https://vimeo.com/163648732',
            'https://vimeo.com/224587374',
            'https://vimeo.com/180364416',
            'https://www.youtube.com/watch?v=zgFyuNmLR24',
            'https://vimeo.com/215043720',
            'https://www.youtube.com/watch?v=I9qCDswG6OY',
            'https://www.youtube.com/watch?v=iZa-QLBhyZk',
            'https://www.youtube.com/watch?v=gpUKrZkuuV4',
            'https://www.youtube.com/watch?v=vIWy6ibtPgI',
            'https://www.youtube.com/watch?v=SuG77f3mdpM',
            'https://www.youtube.com/watch?v=oi9zcOstOt8',
            'https://www.youtube.com/watch?v=k97OG_RRoO4',
            'https://www.youtube.com/watch?v=bTSrutymSk8',
            'https://www.youtube.com/watch?v=x3OXphRnEvM',
            'https://www.youtube.com/watch?v=4JciKnnz2jw',
            'https://www.youtube.com/watch?v=fHPq6-P6tqM',
            'https://vimeo.com/265712855',
            'https://www.youtube.com/watch?v=NIedTlxZnXw',
            'https://www.youtube.com/watch?v=rBs9RbGB2LE',
            'https://www.youtube.com/watch?v=uflnSj9ckQQ',
            'https://www.youtube.com/watch?v=ZIVeU--em7U',
            'https://youtu.be/KH6iC04LN1s',
            'https://youtu.be/uKLzX_eO-L0',
            'https://youtu.be/Mu9zcdMtUjU',
            'https://youtu.be/F_vPQUcLg6Y',
            'https://youtu.be/eToIYQTEaDE',
            'https://youtu.be/p_7hkXoUEfQ',
            'https://youtu.be/kR-wAeqf6-0',
            'https://youtu.be/fgzWCG-0ubE',
            'https://youtu.be/DVGkegFD5Is',
            'https://youtu.be/gaVlWlbPNKI',
            'https://youtu.be/HEKqcTi4cDI',
            'https://youtu.be/7o5Gwx5oWos',
            'https://youtu.be/TkFly11_CPE',
            'https://youtu.be/4niDleosNXo',
            'https://vimeo.com/213938490',
            'https://youtu.be/0uadIEwplCo',
            'https://youtu.be/Y_iprDOmP3E',
            'https://youtu.be/Gs5D5XzSYc4',
            'https://youtu.be/0CrtoTpnPjQ',
            'https://youtu.be/1IH0za05W78',
            'https://youtu.be/WZRgoRiyYTo',
            'https://vimeo.com/383006340',
            'https://youtu.be/a9rX1b5sKgI',
            'https://youtu.be/__khiEsBylg',
            'https://youtu.be/nJ3wGwEomFY',
            'https://youtu.be/UBZQ8i82H08',
            'https://youtu.be/kxf1Oo8BiSg',
            'https://youtu.be/OzoAodNsgRk',
            'https://youtu.be/GxSCnf05hlM',
            'https://youtu.be/WcK5Bc2irm8',
            'https://youtu.be/aOm5wdZWuGg',
            'https://youtu.be/h6iPVcMntj8',
            'https://youtu.be/lOttmcVgGWE',
            'https://youtu.be/jjKqznIFE34',
            'https://youtu.be/EdzqwdPfEDY',
            'https://youtu.be/IOb8TKSOo1I',
            'https://youtu.be/DohHEOwvBv8',
        ],
    },
    {
        id: 'sf',
        name: 'San Francisco',
        smallName: 'SF',
        edito: '',
        subtitle: '',
        about: '',
        bounds: [
            [-122.52026422301677, 37.73189107529478],
            [-122.36978418038728, 37.817769558834755],
        ],
        videos: [
            'https://www.youtube.com/watch?v=fpaKo_ayXRg',
            'https://www.youtube.com/watch?v=Ma7B11b_JM8',
            'https://www.youtube.com/watch?v=Rnww0yG2NMs',
            'https://www.youtube.com/watch?v=_TyeJmt8rR4',
            'https://www.youtube.com/watch?v=LEIZxCCFQoY',
            'https://www.youtube.com/watch?v=fYedE_tRe94',
            'https://www.youtube.com/watch?v=Y0m10OGcw14',
            'https://www.youtube.com/watch?v=v5qQCw257Uw',
            'https://vimeo.com/172720857',
            'https://www.youtube.com/watch?v=GtPnbMYT17M',
            'https://www.youtube.com/watch?v=aTY-rPVeJ_E',
            'https://www.youtube.com/watch?v=GZ1FEESqJSk',
            'https://www.youtube.com/watch?v=HFc3JhoSGZo',
            'https://www.youtube.com/watch?v=6-6bZQ5o0Vc',
            'https://www.youtube.com/watch?v=TfLDy3dwYsQ',
            'https://www.youtube.com/watch?v=yYxDgtK3oV4',
            'https://vimeo.com/209070903',
            'https://www.youtube.com/watch?v=ybrxnEvKp5w',
            'https://www.youtube.com/watch?v=cgiFHll1tBk',
            'https://vimeo.com/194417491',
            'https://www.youtube.com/watch?v=OhQ4lmHWqkQ',
            'https://www.youtube.com/watch?v=eeTFgGV_-OY',
            'https://www.youtube.com/watch?v=lujRIPYEvGg',
            'https://www.youtube.com/watch?v=RlUjeRNAtmM',
            'https://www.youtube.com/watch?v=YYy_KzSr9N4',
            'https://www.youtube.com/watch?v=bUEIFsOmXiQ',
            'https://www.youtube.com/watch?v=sjQ6Dov7qeU',
            'https://www.youtube.com/watch?v=wnFx_jhGzKI',
            'https://www.youtube.com/watch?v=d0U11fMUy34',
            'https://www.youtube.com/watch?v=sjQ6Dov7qeU',
            'https://www.youtube.com/watch?v=dxPQEeYp6G4',
            'https://www.youtube.com/watch?v=d7XlmGyL1-s',
            'https://www.youtube.com/watch?v=CMp1V6ZToY4',
            'https://www.youtube.com/watch?v=0g0LfSRLjrQ',
            'https://www.youtube.com/watch?v=C3jnY2KjW6I',
            'https://www.youtube.com/watch?v=6BDYAMDQLGQ',
            'https://www.youtube.com/watch?v=3WOUiom2NAA',
            'https://vimeo.com/306734733',
            'https://youtu.be/9FA8uXNHabE',
            'https://youtu.be/BXMSpBtjoKo',
            'https://youtu.be/xqrRyXPLeyw',
            'https://youtu.be/TnqRkPQfxKU',
            'https://youtu.be/gyROEunCNJ4',
            'https://youtu.be/bK0K0oOVLz4',
            'https://youtu.be/POPqGTNdeCU',
            'https://youtu.be/014QQLuCoKw',
            'https://youtu.be/b2wSmlSWML8',
            'https://youtu.be/xAt1TRKkTLg',
            'https://youtu.be/NqMhNaLLwS0',
            'https://youtu.be/0ND5O_nbquQ',
            'https://youtu.be/pefmKHwap3I',
            'https://youtu.be/mf8c2P8AiBo',
            'https://youtu.be/3u1XC_3KKxY',
            'https://youtu.be/SIZHJnt02mk',
            'https://youtu.be/3pSA1sYl_DE',
            'https://youtu.be/PLjX5T8AFao',
            'https://youtu.be/hOLoeVyy3AY',
            'https://youtu.be/qcSdzDKijUI',
            'https://youtu.be/voUbmlS4lZM',
            'https://youtu.be/gAF9Cnfeobs',
            'https://youtu.be/eSiIS6zEwkw',
            'https://youtu.be/9MB6hoBalLw',
            'https://youtu.be/fdDpEXxA5Fs',
        ],
    },
];

export default cities;
